export default __webpack_public_path__ + "static/media/puspenerballogo-removebg-preview.7e350089.png";